import styled from 'styled-components';
import { media, colors } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';

export const StyledSection = styled(Section)`
  padding: 0 20px !important;
  margin-top: 20px !important;
  margin-bottom: 40px !important;
  ${media.md`
    padding: 0 40px !important;
  `}
  ${media.lg`
    padding: 0 70px !important;
  `}
  ${media.xl`
    padding: 0 80px !important;
  `}
`;

export const StyledContentBlock = styled(ContentBlock)`
  display: flex;
  max-width: 1240px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px !important;
  margin: 0 auto;
`;

export const MainTitle = styled.h2`
  color: #1c1c1c;
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: 40px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0px;
  text-align: start;
  margin-bottom: 20px;
  width: 100%;

  ${media.md`
    font-size: 60px;
    font-style: normal;
    line-height: 90%; /* 54px */
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    line-height: 85%;
    letter-spacing: -1.4px;
    
  `}
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
  flex-flow: column nowrap;
  text-align: left;

  ${media.md`
    margin-bottom: 10px;
    margin-top: 30px;
  `}
`;

export const StyledH6 = styled.h2`
  font-family: 'Satoshi Variable Medium', sans-serif;
  color: var(--Shades-900, #1c1c1c);
  font-weight: 500;
  margin: 0px;
  font-size: 18px;
  line-height: 140%;
`;

export const StyledParagraph = styled.p`
  color: ${colors.solid.textTwo};
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  width: 100%;
  font-family: 'Satoshi Variable Medium', sans-serif;
  color: var(--Type-body-copy-dark, #6b6d7b);
  margin: 0px;
`;
